/**
 * 简单的封装axios
 */
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'

const $http = axios.create({ baseURL: '/api' })
// 请求时拦截参数
$http.interceptors.request.use(
  config => {
    config = {
      ...config
    }
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    let token = localStorage.getItem('carparkXtoken')
    // 带上token
    if (token && token !== 'undefined') {
      config.headers.xtoken = token
    } else {
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应成功，处理结果
$http.interceptors.response.use(
  response => {
    // 防止死循环：检查是否在短时间内（5秒）已经触发过刷新
    const lastReloadTime = localStorage.getItem('tokenExpiredReloadTime')
    const now = Date.now()

    // 检查是否在授权页面，授权页面不触发重载，防止中断授权流程
    const currentPath = window.location.hash
    const isAuthPage = currentPath.includes('/wxAuth') || currentPath.includes('/alipayAuth')

    if (response.data.code === 'MSYS0004') {
      if (lastReloadTime && now - parseInt(lastReloadTime) < 5000) {
        return Promise.reject(response.data)
      }

      if (isAuthPage) {
        console.warn('授权页面收到 MSYS0004 错误，不触发重载')
        return Promise.reject(response.data)
      }

      localStorage.setItem('openId', '')
      localStorage.setItem('carparkXtoken', '')
      localStorage.setItem('tokenExpiredReloadTime', now.toString())
      // 跳转到当前页面，触发路由守卫的授权流程
      window.location.reload()
      return Promise.reject(response.data)
    }
    if (response.data.code === 'WXK001') {
      if (lastReloadTime && now - parseInt(lastReloadTime) < 5000) {
        return Promise.reject(response.data)
      }

      if (isAuthPage) {
        console.warn('授权页面收到 WXK001 错误，不触发重载')
        return Promise.reject(response.data)
      }

      localStorage.setItem('openId', '')
      localStorage.setItem('carparkXtoken', '')
      localStorage.setItem('tokenExpiredReloadTime', now.toString())
      // 跳转到当前页面，触发路由守卫的授权流程
      window.location.reload()
      return Promise.reject(response.data)
    }
    response = response.data
    const msg = response.msg
    return response
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误'
          break
        case 401:
          err.message = '未授权，请登录'
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`
          break
        case 408:
          err.message = '请求超时'
          break
        case 500:
          err.message = '服务器内部错误'
          break
        case 501:
          err.message = '服务未实现'
          break
        case 502:
          err.message = '网关错误'
          break
        case 503:
          err.message = '服务不可用'
          break
        case 504:
          err.message = '网关超时'
          break
        case 505:
          err.message = 'HTTP版本不受支持'
          break
        default:
      }
    }
    Toast(err.message)
    return Promise.reject(err)
  }
)

export default $http



// WEBPACK FOOTER //
// ./src/utils/http.js